export default {
  templateHeader: {
    title: 'Clone Voice Assets',
    desc: 'Clone custom voices for characters to achieve more lifelike dubbing effects.',
    addVoice: 'Add Clone Voice',
  },
  table: {
    confirmDelete: {
      message: 'Deletion is irreversible. Are you sure to delete?',
      title: 'Delete Voice',
    },
    runningAlert: 'Adding voice, please wait.',
    action: {
      stop: 'Stop',
      play: 'Play',
      edit: 'Edit',
    },
    added: 'Added',
  },
  addVoice: {
    form: {
      sample: 'Audio Sample',
      separation: 'Remove Background Music Simultaneously',
      name: 'Name',
      namePlaceholder: 'Please Enter',
      desc: 'Description',
      descPlaceholder:
        'Please describe this voice. For example: “An older American male voice, slightly raspy, ideal for news broadcasting.”',
      upload: {
        asset: 'Click to add from library',
        tip_1:
          'The ideal audio length is 1-2 minutes (no less than 1 second), clear with no reverb, defects, or background noise. (Supports audio and video)',
        tip_2:
          'Audio quality is the most critical factor affecting cloning results, including the voice itself, language, accent, and recording quality.',
        tip_3:
          'Maintain audio consistency to ensure tone and performance remain stable throughout the process.',
        tip_4:
          'Ensure moderate volume with an ideal range of -23 dB to -18 dB RMS and a true peak of -3 dB.',
        formatError: 'Unsupported File Format',
        durationError:
          'The duration must be longer than {s} second. Please re-upload.',
      },
      edit: 'Edit Voice',
      confirm: 'Add',
    },
    disabledTips: {
      usedSlot: 'The number of added clone voices has reached its limit.',
      voiceEdit: 'Clone voice editing limit for this month has been reached.',
    },
  },
}
